import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 14,
	viewBox: "0 0 10 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.64062 12.1406H3.35938C3.29922 12.1406 3.25 12.1898 3.25 12.25V12.6875C3.25 12.9295 3.44551 13.125 3.6875 13.125H6.3125C6.55449 13.125 6.75 12.9295 6.75 12.6875V12.25C6.75 12.1898 6.70078 12.1406 6.64062 12.1406ZM5 0.875C2.52402 0.875 0.515625 2.8834 0.515625 5.35938C0.515625 7.01914 1.41797 8.46836 2.75781 9.24355V10.8281C2.75781 11.0701 2.95332 11.2656 3.19531 11.2656H6.80469C7.04668 11.2656 7.24219 11.0701 7.24219 10.8281V9.24355C8.58203 8.46836 9.48438 7.01914 9.48438 5.35938C9.48438 2.8834 7.47598 0.875 5 0.875ZM6.74863 8.3918L6.25781 8.67617V10.2812H3.74219V8.67617L3.25137 8.3918C2.17539 7.76973 1.5 6.62402 1.5 5.35938C1.5 3.42617 3.0668 1.85938 5 1.85938C6.9332 1.85938 8.5 3.42617 8.5 5.35938C8.5 6.62402 7.82461 7.76973 6.74863 8.3918Z" })
});
export default SvgBulb;
